<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="256"
      cy="256"
      r="240"
      stroke="#2563EB"
      stroke-width="40"
      fill="none"
    />
    <circle
      cx="256"
      cy="256"
      r="140"
      stroke="#2563EB"
      stroke-width="40"
      fill="none"
    />
    <path
      d="M256 116 C333 116 396 179 396 256 C396 333 333 396 256 396 C179 396 116 333 116 256"
      stroke="#2563EB"
      stroke-width="40"
      fill="none"
      stroke-linecap="round"
    />
    <circle cx="200" cy="310" r="16" fill="#2563EB" />
    <circle cx="312" cy="200" r="16" fill="#2563EB" />
  </svg>
</template>
